// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".column--centered[data-v-d02753b4]{display:flex;align-items:center}@media screen and (min-width:770px){.column--centered .field[data-v-d02753b4]{margin-top:3rem}}.no-results-text[data-v-d02753b4]{width:100%!important;white-space:normal}.no-results-text b[data-v-d02753b4]{font-weight:bolder}.no-results-text ul[data-v-d02753b4]{list-style-type:circle!important}.form-experience [class^=form-][data-v-d02753b4]{margin-top:1.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
